// extracted by css-extract-rspack-plugin
export default {"container":"container-wQjO9p","loading":"loading-FwOpff"};